// extracted by mini-css-extract-plugin
export default {"widget":"ColorPickerLayout_widget__UxjbZ","defaultColorPicker":"ColorPickerLayout_defaultColorPicker__VzfBl","defaultColors":"ColorPickerLayout_defaultColors__-7UcG"};